export const GALLERY_SLIDE_DURATION_IN_MS = 300;
export const GALLERY_SLIDE_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const slideHorizontally = (element: Element, fromOffset: number) => {
  if (window.matchMedia(REDUCED_MOTION_QUERY).matches) {
    return null;
  }

  return element.animate(
    [
      { transform: `translateX(${fromOffset}px)`, opacity: 0.4 },
      { transform: 'translateX(0)', opacity: 1 },
    ],
    { duration: GALLERY_SLIDE_DURATION_IN_MS, easing: GALLERY_SLIDE_EASING },
  );
};
